export const DEBOUNCE_TIMEOUT = 1000;

export const EXPORT_JOB_POLL_INTERVAL_MS = 1000;
export const MAX_EXPORT_JOB_POLL_ATTEMPTS = 120;

export const DIFFERED_SEARCH_QUERY_DELAY_MS = 600;
